import cx from 'classnames';
import React from 'react';
import { Tag } from '~/types/models/tags';
import TagColorRadioButton from '../TagColorPicker/TagColorRadioButton';
import { toLower } from 'lodash';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TagListItemProps {
  tag: Tag;
  className?: string;
  onTagNameChange?: (tag: Tag, name: string) => void;
  onDeleteClick?: () => void;
}

export default function TagListItem({
  tag,
  className,
  onTagNameChange,
  onDeleteClick
}: TagListItemProps){
  const { name, color } = tag;

  return (
    <div className={cx(className, 'flex flex-row items-center')}>
      <TagColorRadioButton
        buttonClassName='w-4 h-4'
        containerClassName="flex my-0 mr-3"
        name='tag-list-item'
        tagColorName={toLower(name)}
        tagColor={color}
        disabled
      />
      <input
        type='text'
        className='form-control mr-4 basis-5/6 !text-neutral-600'
        placeholder="Tag name"
        onChange={(event: React.FormEvent<HTMLInputElement>) =>
          onTagNameChange?.(tag, event.currentTarget.value)
        }
        defaultValue={name}
      />
      <FontAwesomeIcon
        className='text-neutral-400 flex mx-auto cursor-pointer hover:text-pink-900'
        size='1x'
        icon={faTrash}
        onClick={onDeleteClick}
      />
    </div>
  );
}
